import { To } from "react-router";

import { MapPanel } from "~/modules/map/components/MapPanel";
import { MAP_MARGIN, MAP_PADDING_BAR_VERTICAL } from "~/modules/map/mapConstants";

import { UserGroup } from "../hooks/useReviewPlanVisitGrouping";
import { ReviewPlanHeader } from "./ReviewPlanHeader";
import { ReviewPlanPendingChanges } from "./ReviewPlanPendingChanges";
import { ReviewPlanSuccessState } from "./ReviewPlanSuccessState";

type ReviewPlanMapPanelProps = {
    isSuccessState: boolean;
    userGroups: UserGroup[];
    selectedVisitIds: string[];
    isAllSelected: boolean;
    onToggleVisit: (visitId: string) => void;
    onToggleAll: () => void;
    onToggleUser: (userId: string | null) => void;
    isUserFullySelected: (userId: string | null) => boolean;
    isUserPartiallySelected: (userId: string | null) => boolean;
    getUserSelectedCount: (userId: string | null) => number;
    onConfirmSelection: () => void;
    onCancelSelection: () => void;
    visitHref: (plannerAreaId: string, plannerVisitId: string) => To;
    areaNameHref: (plannerAreaId: string) => To;
    onReviewMoreClick: () => void;
    backHref: To;
    loading: boolean;
    totalDraftVisits: number;
};

export function ReviewPlanMapPanel({
    isSuccessState,
    userGroups,
    selectedVisitIds,
    isAllSelected,
    onToggleVisit,
    onToggleAll,
    onToggleUser,
    isUserFullySelected,
    isUserPartiallySelected,
    getUserSelectedCount,
    onConfirmSelection,
    onCancelSelection,
    visitHref,
    areaNameHref,
    backHref,
    loading,
    totalDraftVisits,
    onReviewMoreClick,
}: ReviewPlanMapPanelProps) {
    return (
        <MapPanel sx={{ height: `calc(100vh - (${MAP_MARGIN}px + ${MAP_PADDING_BAR_VERTICAL}px))` }}>
            <ReviewPlanHeader backHref={backHref} />

            {isSuccessState ? (
                <ReviewPlanSuccessState
                    onReviewMoreClick={onReviewMoreClick}
                    totalDraftVisits={totalDraftVisits}
                    backHref={backHref}
                />
            ) : (
                <ReviewPlanPendingChanges
                    loading={loading}
                    visitHref={visitHref}
                    areaNameHref={areaNameHref}
                    userGroups={userGroups}
                    selectedVisitIds={selectedVisitIds}
                    isAllSelected={isAllSelected}
                    onToggleVisit={onToggleVisit}
                    onToggleAll={onToggleAll}
                    onToggleUser={onToggleUser}
                    isUserFullySelected={isUserFullySelected}
                    isUserPartiallySelected={isUserPartiallySelected}
                    getUserSelectedCount={getUserSelectedCount}
                    onConfirmSelection={onConfirmSelection}
                    onCancelSelection={onCancelSelection}
                />
            )}
        </MapPanel>
    );
}
